function getPathName (route){
    return route.toLowerCase();
}
export default getPathName;